var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.128,
    height: 45.169,
    viewBox: "0 0 73.128 45.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(-3585.697 -4521.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M3613.657,4543.931a22.538,22.538,0,0,1,8.6-17.731,22.584,22.584,0,1,0,0,35.461A22.538,22.538,0,0,1,3613.657,4543.931Z",
    fill: "#ea001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M3636.241,4521.346a22.483,22.483,0,0,0-13.98,4.854,22.569,22.569,0,0,1,0,35.461,22.582,22.582,0,1,0,13.98-40.315Z",
    fill: "#f69d1b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 8.605,
    cy: 17.73,
    rx: 8.605,
    ry: 17.73,
    transform: "translate(3613.656 4526.2)",
    fill: "#ff5f00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMasterCard);
export default __webpack_public_path__ + "static/media/iconMasterCard.8552e8921e48f61a605905d4ee3138d4.svg";
export { ForwardRef as ReactComponent };